import { render, staticRenderFns } from "./sortBtn.vue?vue&type=template&id=696be16b&scoped=true&"
import script from "./sortBtn.vue?vue&type=script&lang=js&"
export * from "./sortBtn.vue?vue&type=script&lang=js&"
import style0 from "./sortBtn.vue?vue&type=style&index=0&id=696be16b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696be16b",
  null
  
)

export default component.exports